module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/sales-channels/sales-sub-channel-terminal/sales-sub-channel-terminal.component.scss
// module id = ./src/app/routes/sales-channels/sales-sub-channel-terminal/sales-sub-channel-terminal.component.scss
// module chunks = 9